import cx from 'clsx';
import React, { memo } from 'react';

import styles from '@/components/BottomNavigation/BottomNavigation.module.scss';
import BottomNavigationSlot from '@/components/BottomNavigation/BottomNavigationSlot';
import {
  BottomNavigationItem,
  BottomNavigationProps,
} from '@/components/BottomNavigation/types';

import { createRel } from './ItemGame';

interface ItemDefaultProps {
  item: BottomNavigationItem;
  index: number;
  onDefaultItemClick: BottomNavigationProps['onBottomNavigationItemClick'];
}

const ItemDefault: React.FC<ItemDefaultProps> = memo(
  ({ item, index, onDefaultItemClick }) => {
    const handleDefaultItemClick = (
      event: React.MouseEvent<HTMLAnchorElement>
    ) => {
      const { route_link } = item;
      event.preventDefault();

      onDefaultItemClick &&
        onDefaultItemClick({
          itemTitle: item.tracking_metadata?.title || item.title,
          path: route_link,
        });
    };

    return (
      <div className={cx(styles.slot)} key={index} data-testid="slot">
        <a
          className={styles.link}
          onClick={handleDefaultItemClick}
          target="_self"
          href={item.route_link}
          rel={createRel(item)}
        >
          <BottomNavigationSlot item={item} />
        </a>
      </div>
    );
  }
);

export default ItemDefault;
